import { createContext } from 'react';

export const AOIContext = createContext({});